export const defaultStyles = `
html, body {
    all: unset;
}

html {
    font-family: system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
}

a, a:visited, a:hover, a:active {
    color: inherit;
}
`;
